import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getReportList } from '@/utils/report';

export const procedureReportListRoute: RouteConfig = {
  path: 'reports/list',
  name: 'procedureReportList',
  component: () =>
    import(/* webpackChunkName: "ProcedureReports" */ '@/views/mainRoute/procedure/details/ReportList.vue'),
  beforeEnter: (to, from, next) => {
    getReportList(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
